import React from 'react';

// Static imports for CRA compatibility (import.meta.glob is Vite-only)
import logo1 from '../assets/partners/CAREINTERNATIONALONG.png';
import logo2 from '../assets/partners/CENTRENATIONALDETRANSFUSIONSANGUINECNTS.png';
import logo3 from '../assets/partners/CHUDEBOUAKE.png';
import logo4 from '../assets/partners/ECOLEPEPINIEREIIPLATEAUX.png';
import logo5 from '../assets/partners/ENVALLABORATOIREYAMOUSSOUKRO.png';
import logo6 from '../assets/partners/HOODAGRAPHICS.png';
import logo7 from '../assets/partners/HOPITALCATHOLIQUESAINTJOSEPHMOSCATI.jpg';
import logo8 from '../assets/partners/IPASCÔTEDIVOIRE.jpg';
import logo9 from '../assets/partners/IVOIRECONSTRUCTION.jpg';
import logo10 from '../assets/partners/IVOIRESURETEPORTUAIREISP.png';
import logo11 from '../assets/partners/LAHAUTEAUTORITEDELACOMMUNICATIONAUDIOVISUELLEHACA.png';
import logo12 from '../assets/partners/LASSIREINDUSTRIE.jpg';
import logo13 from '../assets/partners/ONECI.png';
import logo14 from '../assets/partners/OMACIOILANDMARITIMEANGEN.png';
import logo15 from '../assets/partners/PROJETDESAUVEGARDEETDEVALORISATIONDELABAIEDECOCODYETDELALAGUNEEBRIEPABC.png';
import logo16 from '../assets/partners/PROJETDURGENCEAGRICOLEDECÔTEDIVOIREPUACI.png';
import logo17 from '../assets/partners/SOFITEL-LOGO-Bandeau-Novojob.jpg';
import logo18 from '../assets/partners/SOGBGRANDBEREBY.png';
import logo19 from '../assets/partners/STATIONTOTALKENEYA.jpg';

const availableLogos = [
  { name: 'CARE INTERNATIONAL ONG', url: logo1 },
  { name: 'CENTRE NATIONAL DE TRANSFUSION SANGUINE', url: logo2 },
  { name: 'CHU DE BOUAKÉ', url: logo3 },
  { name: 'ÉCOLE PÉPINIÈRE IIPLATEAUX', url: logo4 },
  { name: 'ENVAL LABORATOIRE YAMOUSSOUKRO', url: logo5 },
  { name: 'HOODA GRAPHICS', url: logo6 },
  { name: 'HÔPITAL CATHOLIQUE SAINT JOSEPH MOSCATI', url: logo7 },
  { name: 'IPAS CÔTE D\'IVOIRE', url: logo8 },
  { name: 'IVOIRE CONSTRUCTION', url: logo9 },
  { name: 'IVOIRE SÛRETÉ PORTUAIRE ISP', url: logo10 },
  { name: 'HAUTE AUTORITÉ DE LA COMMUNICATION AUDIOVISUELLE HACA', url: logo11 },
  { name: 'LASSIRE INDUSTRIE', url: logo12 },
  { name: 'ONECI', url: logo13 },
  { name: 'OMACI OIL AND MARITIME ANGEN', url: logo14 },
  { name: 'PROJET SAUVEGARDE BAIE DE COCODY LAGUNE EBRIÉ PABC', url: logo15 },
  { name: 'PROJET URGENCE AGRICOLE DE CÔTE D\'IVOIRE PUACI', url: logo16 },
  { name: 'SOFITEL NOVOJOB', url: logo17 },
  { name: 'SOGB GRAND BEREBY', url: logo18 },
  { name: 'STATION TOTAL KENEYA', url: logo19 },
];

const Partners = () => {
  // We duplicate the array to allow for a seamless infinite scroll
  const duplicatedLogos = [...availableLogos, ...availableLogos];

  return (
    <section className="logo-ticker-container bg-white overflow-hidden py-16 w-full">
      <div className="text-center max-w-2xl mx-auto mb-16 px-4">
        <h2 className="text-3xl md:text-5xl font-extrabold mb-4 text-cidh-blue font-montserrat uppercase tracking-tight">
          Ils nous font confiance
        </h2>
        <div className="w-24 h-1.5 bg-cidh-gold mx-auto mb-6 rounded-full"></div>
        <p className="text-cidh-gray-text text-lg">Découvrez les organisations qui nous accompagnent dans nos missions.</p>
      </div>

      {/* Full width container for the continuous marquee */}
      <div className="w-full overflow-hidden relative group py-4">
        {/* Left and right gradient masks for a smooth fade-in/-out effect */}
        <div className="absolute top-0 left-0 w-16 md:w-32 h-full bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>
        <div className="absolute top-0 right-0 w-16 md:w-32 h-full bg-gradient-to-l from-white to-transparent z-10 pointer-events-none"></div>

        <div className="flex w-max animate-scroll-slow pb-4">
          {duplicatedLogos.map((partner, idx) => (
            <div 
              key={`partner-${idx}`} 
              className="flex-shrink-0 flex items-center justify-center h-28 md:h-32 p-4 bg-white border border-gray-100 shadow-sm rounded-xl hover:shadow-lg transition-shadow duration-300 logo-card"
              title={partner.name}
            >
              <img 
                src={partner.url} 
                alt={partner.name}
                className="max-w-full max-h-[85px] object-contain filter drop-shadow-sm"
              />
            </div>
          ))}
        </div>
      </div>
      
      <style dangerouslySetInnerHTML={{__html: `
        .logo-ticker-container {
          --partner-gap: 2rem;
        }
        .logo-card {
          /* Par défaut (Grands écrans PC) : 6 logos */
          width: calc((100vw - (6 * var(--partner-gap))) / 6);
          margin-left: calc(var(--partner-gap) / 2);
          margin-right: calc(var(--partner-gap) / 2);
        }
        /* Ecrans moyens (Tablettes / Petits PC) : 4 logos */
        @media (max-width: 1024px) {
          .logo-card {
            width: calc((100vw - (4 * var(--partner-gap))) / 4);
          }
        }
        /* Ecrans téléphones : 3 logos */
        @media (max-width: 768px) {
          .logo-card {
            width: calc((100vw - (3 * var(--partner-gap))) / 3);
          }
        }
        /* Très petits téléphones : 2 logos */
        @media (max-width: 480px) {
          .logo-card {
            width: calc((100vw - (2 * var(--partner-gap))) / 2);
          }
        }
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll-slow {
          animation: scroll ${Math.max(30, availableLogos.length * 3)}s linear infinite;
        }
        .group:hover .animate-scroll-slow {
          animation-play-state: paused;
        }
      `}} />
    </section>
  );
};

export default Partners;
